{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Se alle alternativer",
  "Spoiler_Reveal_Tooltip": "Klikk for å avsløre",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweet dette",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Element er skjult",
  "Spoiler_Reveal_Video_CTA": "Avslør video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Utvid bildet",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Se alle resultater",
  "Spoiler_Reveal_Image_Placeholder": "Dette bildet inneholder en spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Glidebryter for søk",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Du kan stemme på mer enn ett svar.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Vis flere lydkontroller",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Lukk",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Laster inn {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Brukeravatar",
  "Preview_ReadMore_Label": "Les mer",
  "Spoiler_Insert_Tooltip": "Sensurfilter",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volum",
  "Spoiler_Reveal_Gallery_Placeholder": "Dette galleriet inneholder en spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Book nå",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Opphev demping",
  "Spoiler_Reveal_Gallery_CTA": "Avslør galleri",
  "Poll_Viewer_ShowLess_CTA": "Vis mindre",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Demp",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonyme",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Følg",
  "VerticalEmbed_Products_Button": "Kjøp nå",
  "Poll_Viewer_Toast_Error_ServerDown": "Kunne ikke koble til server. Prøv igjen senere.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} person stemte på dette svaret",
  "Poll_Viewer_VoteCount": "{{number}} stemmer",
  "VerticalEmbed_Events_Button": "Registrer deg nå",
  "Spoiler_Reveal_Image_CTA": "Avslør bilde",
  "Poll_Viewer_Toast_Error_Connection": "Ikke noe internett. Sjekk tilkoblingen din.",
  "Poll_Viewer_Visibility_Owner_Footer": "Kun du kan se resultatene.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} personer stemte på dette svaret",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Element er utvidet",
  "Audio_Plugin_Cover_Alt": "Lyddeksel",
  "Spoiler_Reveal_Video_Placeholder": "Denne videoen inneholder en spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Se hele innlegget",
  "UploadFile_Viewer_Download": "Last ned {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}t",
  "VerticalEmbed_Units_Minute": "{{minutes}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
